<template>
  <div>
    <div class="">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="已開立" name="invoiced">
          <invoiced />
        </el-tab-pane>
        <el-tab-pane label="未開立" name="avalible">
          <avalible />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { getInvoices, deleteInvoices, getInvoice } from '@/api/invoice';
import invoiced from './components/invoiced.vue';
import avalible from './components/avalible.vue';
const methods = {
  handleClick(tab, event) {},
};
export default {
  components: { invoiced, avalible },
  data() {
    return {
      activeName: 'invoiced',
    };
  },
  methods,
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}
.el-table .danger {
  background: #5858583b;
}
.padding {
  padding: 1rem;
}
</style>
